import { ReactNode } from 'react';
import { Control, FieldError, FieldErrors, FieldValues } from 'react-hook-form';

import {
  Collapsible,
  CollapsibleProps,
  Input,
} from 'apps/shared/scripts/components';

interface OwnProps<T extends FieldValues> {
  active?: string;
  children?: ReactNode;
  control: Control<T>;
  dirtyFields: Object;
  errors: FieldErrors<T>;
  label: string;
  name: string;
}

type Props<T extends FieldValues> = OwnProps<T> & CollapsibleProps;

const CollapsibleSettingsInput = <T extends FieldValues>({
  active,
  control,
  children,
  dirtyFields,
  errors,
  label,
  name,
  isSaving,
  onCancel,
  onEdit,
  onSave,
  ...props
}: Props<T>) => {
  return (
    <Collapsible
      control={control}
      error={errors[name] as FieldError}
      isActive={active === name}
      isDirty={name in dirtyFields}
      isDisabled={!!active && active !== name}
      isSaving={isSaving}
      label={label}
      onCancel={onCancel}
      onEdit={() => onEdit(name)}
      onSave={onSave}
      name={name}
      {...props}
    >
      {children ?? <Input control={control} name={name} />}
    </Collapsible>
  );
};

CollapsibleSettingsInput.displayName = 'CollapsibleSettingsInput';

export default CollapsibleSettingsInput;
